// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__34z2A","content":"RecentSearches_content__25jzl"};